import { AfterViewInit, Component, ElementRef, NgZone, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material';
import { environment } from '../../../../environments/environment';
import { HttpBaseService } from '../../../core/http-base.service';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ShellService } from '../../../core/shell.service';
//import { DatePipe } from '@angular/common';
import { cpf } from 'cpf-cnpj-validator';
import { LicitabenAssinaturaService } from './licitaben-assinatura.service';
import { setDatepicker, validarAnobrowser, validateAllFormFields } from '../../../constantes';
import * as moment from 'moment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { DomSanitizer } from '@angular/platform-browser';
import { Dominio } from '../../../models/integra/Dominio';
import { Observable } from 'rxjs';
import { map, startWith } from "rxjs/operators";
import { COMMA, ENTER } from "@angular/cdk/keycodes";
import { NavegacaoService } from '../../../core/navegacao.service';
import { LicitabenLicitacao } from '../../../models/integra/licitaben-licitacao';


@Component({
  templateUrl: './licitaben-assinatura.component.html',
  styleUrls: ['./licitaben-assinatura.component.scss']
})


export class LicitabenAssinaturaComponent implements OnInit {

  hoje: any = new Date();;//new Date(moment(Date.now()).format('YYYY-MM-DD'));

  public formGroup: FormGroup;
  public entity: LicitabenLicitacao;

  public showCadastro: boolean = true;
  public showErro: boolean = false;
  public showConcluir: boolean = false;
  public showCampos: boolean = true;
  public showLogin: boolean = false;
  public camposOk: boolean = false;
  public showAvisoTexto: boolean = false;
  public licitacaoEncontrada:boolean = true;
  public chave: string;
  public numLicitacao: string;
  public dscResponsavel: string;
  public objeto: string;
  public dataAssinatura: any;
  public dataLancamento: any;
  public dataEncerramento: any;
  

  constructor(
    private http: HttpBaseService,
    private httpClient: HttpClient,
    private navegacaoService: NavegacaoService,
    public dialog: MatDialog,
    private route: ActivatedRoute,
    private shellService: ShellService,
    private formBuilder: FormBuilder,
    private router: Router,
    private _ServicePesquisa: LicitabenAssinaturaService,
    private _ngZone: NgZone,
    //private datePipe: DatePipe,
    private _sanitizer: DomSanitizer,
    //private credenciaisService: CredenciaisService

  ) {
    //console.log("this.route.snapshot.params.id",this.route.snapshot.params.id)
    this.chave = this.route.snapshot.params.id;
  }

  ngOnInit(): void {
    this.http.get("/LicitabenLicitacaoProposta/VerificaAssinaturaLicitacao/" + this.chave, false).subscribe(result => {
      //console.log("ngOnInit---VerificaAssinaturaLicitacao",result)
      let dataass = result.dtHistorico == "1900-01-01T00:00:00" ? result.dtAprovacaoProposta :  result.dtHistorico;
      this.licitacaoEncontrada = result!=null;
      //let formattedDate = (moment(result.dtHistorico)).format('DD-MMM-YYYY HH:mm:ss')
      this.numLicitacao = result.numLicitacao;
      this.dscResponsavel = result.responsavelEntidade;
      this.objeto = result.objeto;
      this.dataLancamento = result.dtLancamento;
      this.dataEncerramento = result.dtEncerramento;
      this.dataAssinatura =(moment(dataass)).format('DD/MM/YYYY HH:mm:ss')
    });
  }
}
